import React from "react";
import PropTypes from "prop-types";

import EpgAPI from "../api/epgAPI";
import EPGModal from "../components/EPGModal.js";

class EPG extends React.Component {
  constructor(props) {
    super(props);

    this.epgChannelID = props.epgChannelID;

    this.state = {
      epgInfo: props.epgInfo,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.epgInfo !== this.props.epgInfo) {
      this.setState({ epgInfo: nextProps.epgInfo });
    }
  }

  render() {
    const actualEPG = this.state.epgInfo.get(this.epgChannelID);

    let actualEvent = undefined;
    if (actualEPG !== undefined) {
      actualEvent = EpgAPI.getCurrentEventEPG(actualEPG.events);
    }

    let title = undefined;
    let startTime = undefined;
    let endTime = undefined;
    let description = undefined;
    let coverURL = undefined;
    if (actualEvent !== undefined) {
      title = actualEvent.title;
      startTime = actualEvent.start;
      endTime = actualEvent.end;
      description = actualEvent.description;
      coverURL = actualEvent.cover;
    }

    return (
      <div style={{ display: "flex" }}>
        {coverURL && (
          <img
            style={{
              width: "110px",
              height: "100%",
              maxHeight: "100%",
              marginTop: "10px",
              marginBottom: "10px",
              borderRadius: ".25rem",
            }}
            src={coverURL}
            alt="logo"
          />
        )}

        <div style={{ marginLeft: "15px" }}>
          <p className="title-epg">En directo: {title}</p>
          <i>
            {EpgAPI.timestampToHoursMinutes(startTime)} -{" "}
            {EpgAPI.timestampToHoursMinutes(endTime)}
          </i>
          <br />
          {description}
          <br />

          <EPGModal
            epgInfo={this.state.epgInfo}
            epgChannelID={this.epgChannelID}
          ></EPGModal>
        </div>
      </div>
    );
  }
}

EPG.propTypes = {
  epgInfo: PropTypes.object,
  epgChannelID: PropTypes.string,
};

EPG.defaultProps = {
  epgInfo: new Map(),
};

export default EPG;
